import { Injectable, inject } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { TotpLockService } from '@app/core/services/totp-lock.service';
import { TOTP_LOCK_SCOPE } from '@app/core/http/totp-lock-scope.context';
import { readTotpLock } from '@app/domain/models/errors/totp-lock';

/**
 * UNA sola responsabilidad: si una respuesta dice que el segundo factor quedó
 * bloqueado por intentos (429 `TOTP_LOCKED`), lo anuncia a `TotpLockService`.
 *
 * No decide nada más: repropaga el error TAL CUAL (la pantalla sigue viéndolo)
 * y no abre ningún modal. Vive aparte de `auth.interceptor.ts` a propósito —
 * CLAUDE.md prohíbe sumarle responsabilidades a ese monolito—.
 *
 * Nunca lee ni registra el cuerpo de la PETICIÓN (lleva el `totp_code`).
 */
@Injectable()
export class TotpLockInterceptor implements HttpInterceptor {
  private readonly totpLock = inject(TotpLockService);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: unknown) => {
        if (error instanceof HttpErrorResponse) {
          const lock = readTotpLock(error.status, error.error, error.headers?.get('Retry-After'));
          // El ámbito lo marcó el ORIGEN de la petición (la recuperación de
          // contraseña cuenta aparte en banca); sin marca, el principal.
          if (lock) this.totpLock.lock(lock.retryAfterSeconds, Date.now(), request.context.get(TOTP_LOCK_SCOPE));
        }
        return throwError(() => error);
      }),
    );
  }
}
